export const isVideo = (fileUrl) => {
  return (
    fileUrl &&
    (fileUrl.endsWith(".mp4") ||
      fileUrl.endsWith(".webm") ||
      fileUrl.endsWith(".ogg") ||
      fileUrl.endsWith(".avi") ||
      fileUrl.endsWith(".3gp") ||
      fileUrl.endsWith(".mov") ||
      fileUrl.endsWith(".flv") ||
      fileUrl.endsWith(".wmv") ||
      fileUrl.endsWith(".mkv") ||
      fileUrl.endsWith(".mpg"))
  );
};

export const isImage = (fileUrl) => {
  return (
    fileUrl &&
    (fileUrl.endsWith(".jpg") ||
      fileUrl.endsWith(".jpeg") ||
      fileUrl.endsWith(".png") ||
      fileUrl.endsWith(".gif") ||
      fileUrl.endsWith(".webp") ||
      fileUrl.endsWith(".heic") ||
      fileUrl.endsWith(".tiff") ||
      fileUrl.endsWith(".bmp") ||
      fileUrl.endsWith(".svg"))
  );
};
